export const lazyLoad = (getter) => {
    let value;
    return () => {
        if (!value) {
            value = getter();
        }
        return value;
    };
};
